/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Diamantready_Name1Inputs */

const en_resources_diamantready_name1 = /** @type {(inputs: Resources_Diamantready_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diamond Ready Orders`)
};

const fr_resources_diamantready_name1 = /** @type {(inputs: Resources_Diamantready_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes Diamant Prêtes`)
};

const es_resources_diamantready_name1 = /** @type {(inputs: Resources_Diamantready_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos Diamond Listos`)
};

const de_resources_diamantready_name1 = /** @type {(inputs: Resources_Diamantready_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diamant Bereit Bestellungen`)
};

const nl_resources_diamantready_name1 = /** @type {(inputs: Resources_Diamantready_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diamant Klaar Bestellingen`)
};

/**
* | output |
* | --- |
* | "Diamond Ready Orders" |
*
* @param {Resources_Diamantready_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_diamantready_name1 = /** @type {((inputs?: Resources_Diamantready_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Diamantready_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_diamantready_name1(inputs)
	if (locale === "fr") return fr_resources_diamantready_name1(inputs)
	if (locale === "es") return es_resources_diamantready_name1(inputs)
	if (locale === "de") return de_resources_diamantready_name1(inputs)
	return nl_resources_diamantready_name1(inputs)
});
export { resources_diamantready_name1 as "resources.diamantReady.name" }